export function vsOutcomeTypeId(marketTypeId: number, sortOrder: number): string {
  return String(marketTypeId * 1000 + sortOrder);
}

const BASEBALL_FINAL_ORDER = [
  'STRIKEOUT',
  'WALK',
  'FLYOUT',
  'GROUNDOUT',
  'HIT',
  'HOMERUN',
  'HITBYPITCH',
] as const;

type BaseballFinalOutcome = (typeof BASEBALL_FINAL_ORDER)[number];

export function baseballFinalOutcomeOutcomeTypeId(finalOutcome: BaseballFinalOutcome): string {
  const idx = BASEBALL_FINAL_ORDER.indexOf(finalOutcome);
  if (idx < 0) throw new Error(`Unknown baseball final outcome: ${finalOutcome}`);
  return vsOutcomeTypeId(4001, idx + 1);
}

export function baseballFinalOutcomePitchesOutcomeTypeId(args: {
  finalOutcome: BaseballFinalOutcome;
  pitchN: 1 | 2 | 3 | 4 | 5 | 6 | 7;
}): string {
  const { finalOutcome, pitchN } = args;
  const minPitch = finalOutcome === 'STRIKEOUT' ? 3 : finalOutcome === 'WALK' ? 4 : 1;
  if (pitchN < (minPitch as any)) throw new Error(`Unsupported baseball combo: ${finalOutcome} + ${pitchN} PITCHES`);

  const countsBefore = (() => {
    // matches default seed ordering in virtual-core
    if (finalOutcome === 'STRIKEOUT') return 0;
    if (finalOutcome === 'WALK') return 5;
    if (finalOutcome === 'FLYOUT') return 9;
    if (finalOutcome === 'GROUNDOUT') return 16;
    if (finalOutcome === 'HIT') return 23;
    if (finalOutcome === 'HOMERUN') return 30;
    if (finalOutcome === 'HITBYPITCH') return 37;
    return 0;
  })();

  const sortOrder = countsBefore + (pitchN - (minPitch as any) + 1);
  return vsOutcomeTypeId(4003, sortOrder);
}

export function baseballFinalOutcomeUnderOverOutcomeTypeId(args: {
  finalOutcome: BaseballFinalOutcome;
  side: 'UNDER' | 'OVER';
}): string {
  const { finalOutcome, side } = args;
  const idx = BASEBALL_FINAL_ORDER.indexOf(finalOutcome);
  if (idx < 0) throw new Error(`Unknown baseball final outcome: ${finalOutcome}`);
  const sideOrder = side === 'UNDER' ? 1 : 2;
  return vsOutcomeTypeId(4004, idx * 2 + sideOrder);
}

